<p class="debugMessage"><small>Account-Manage:</small></p>

<ng-template #PageLoadingTemplate>
	<app-loading-template DisplayText="Please wait while we load your account details" />
</ng-template>

<ng-container *ngIf="selectedAccount else PageLoadingTemplate">
	<nav class="navbar navbar-expand-lg bg-body-tertiary" *ngIf="selectedAccount">
		<span style="font-weight: bold;">{{selectedAccount.Name}}</span>
		<span class="me-auto"></span>
		<!-- #35 Add an Account Expiry Warning and Trial warning -->
		<app-account-expiry [selectedAccount]="selectedAccount" [Banner]="true" />
		<span class="app-icon app-icon--edit" (click)="editAccount(selectedAccount)"><mat-icon /></span>
	</nav>

	<div class="account-overview" *ngIf="selectedAccount">
		<table class="account-details">
			<colgroup>
				<col class="account-details-label">
				<col class="account-details-value">
				<col class="account-details-address">
				<col class="account-details-label">
				<col class="account-details-value">
			</colgroup>
			<thead>
				<tr>
					<th colspan="2" class="table-header">
						<div style="display: flex;">
							<span>Account Information</span>
						</div>
					</th>
				</tr>
			</thead>
			<tr>
				<th>Name:</th>
				<td>{{selectedAccount.Name}}</td>
				<th>Address:</th>
				@if (selectedAccount.Expiry !== 0) {
				<th>Expires:</th>
				<td>{{selectedAccount.Expiry | date:'dd MMMM yyyy'}}</td>
				}
			</tr>

			<tr>
				<th>Description:</th>
				<td>{{selectedAccount.Description}}</td>
				<td rowspan="2" style="vertical-align: top;">{{selectedAccount.Address}}</td>
				@if (selectedAccount.Trial) {
				<th>Trial:</th>
				<td>This is a trial Account</td>
				}
			</tr>
			<tr>
				<th>Owner:</th>
				<td>{{selectedAccount.Owner}}</td>
			</tr>
		</table>
	</div>

	<ejs-tab [selectedItem]="selectedTab" (selected)="tabChange($event)">
		<e-tabitems>
			<e-tabitem *ngFor="let tab of lstTabs" [hidden]="tab.adminOnly && !currentUser.AdminSite">
				<ng-template #headerText>
					<span class="alignRow" [ngClass]="{'siteAdmin-only' : tab.adminOnly}" [matTooltip]="'Admin Only'"
						[matTooltipDisabled]="!tab.adminOnly">
						<mat-icon>{{ tab.icon }}</mat-icon>&nbsp;
						<span>{{ tab.title }}</span>
					</span>
				</ng-template>
				<ng-template #content>
					<app-account-manage-users *ngIf="tab.name === 'users'" [accountGUID]="accountGUID" />
					<app-account-manage-groups *ngIf="tab.name === 'groups'" [accountGUID]="accountGUID" />
					<app-account-manage-organisations *ngIf="tab.name === 'sites'" [accountGUID]="accountGUID" />
					<app-account-manage-features *ngIf="tab.name === 'features'" [accountGUID]="accountGUID" />
				</ng-template>
			</e-tabitem>
		</e-tabitems>
	</ejs-tab>
</ng-container>